export const Footer = () => {
  return (
    <footer className="mt-auto py-3 border-t dark:border-white/10 bg-white dark:bg-bgdark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center">
          Copyright © 2020-{new Date().getFullYear()} UPCX-PLATFORMS PTE. LTD.
        </p>
      </div>
    </footer>
  );
};
